import { render, staticRenderFns } from "./AboutType.vue?vue&type=template&id=4d0695aa"
import script from "./AboutType.vue?vue&type=script&lang=js"
export * from "./AboutType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports